import { render, staticRenderFns } from "./SysMessageList.vue?vue&type=template&id=3014f955&scoped=true&"
import script from "./SysMessageList.vue?vue&type=script&lang=js&"
export * from "./SysMessageList.vue?vue&type=script&lang=js&"
import style0 from "./SysMessageList.vue?vue&type=style&index=0&id=3014f955&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3014f955",
  null
  
)

export default component.exports